<template>
    <div>
        <div>
            <Titulo :titulo="'Informes - '" />
        </div>
        <div class="margin-informes">
            <table-component
                :data="data"
                @click-buscar="index"
                @click-event="clickEvent"
                :perPage="perPage"
                @checkbox="checkbox"
                filtro
                showFilterDates
                :dataLength="dataLength"
                :pagination="true"
                :showMessage="true"
            >
                <table-column
                    slot="label"
                    :label="'Seleccione'"
                    v-bind:value="'checkbox:sig_garantia_id'"
                    style="max-width: 10px"
                    customClass="text-center"
                ></table-column>
                <table-column
                    slot="label"
                    :label="'Garantia'"
                    v-bind:value="'sig_garantia_id'"
                    customClass="text-center"
                ></table-column>
                <table-column
                    slot="label"
                    :label="'Nombre'"
                    v-bind:value="'nombre'"
                    customClass="text-center"
                ></table-column>
                <table-column
                    slot="label"
                    :label="'Cedula'"
                    v-bind:value="'cedula'"
                    customClass="text-center"
                ></table-column>
                <table-column
                    slot="label"
                    :label="'Pagare'"
                    v-bind:value="'pagare'"
                    customClass="text-center"
                ></table-column>
                <table-column
                    slot="label"
                    :label="'Convenio'"
                    v-bind:value="'convenio'"
                    customClass="text-center"
                ></table-column>
                <table-column
                    slot="label"
                    :label="'Acciones'"
                    :customClass="'text-center'"
                >
                    <table-column
                        slot="icon"
                        :icon="'fa fa-search-plus'"
                        :class="'btn btn-sm btn-info'"
                        :slug="'observacion'"
                        :tooltip="'Observación'"
                    ></table-column>
            </table-column>
            </table-component>
            <b-row>
                <b-col sm="6" class="text-left">
                <b-button
                    variant="outline-success"
                    :disabled="item.length == 0 || loading"
                    block
                    @click="aplicarFraude('aprobado')"
                >
                    <i class="fa fa-check-square-o"></i> Aprobar Fraude
                </b-button>
                </b-col>
                <b-col sm="6" class="text-right">
                <b-button
                    variant="outline-danger"
                    :disabled="item.length == 0 || loading"
                    block
                    @click="aplicarFraude('no aprobado')"
                >
                    <i class="fa fa-times-circle"></i> No Aprobar Fraude
                </b-button>
                </b-col>
            </b-row>
            <b-modal id="modal-1" title="Detalle del caso" hide-footer size="xl">
                <div class="m-5" v-if="observacion">
                <h3 class="color-secundary">Información del caso</h3>
                <div class>
                    <div class="container">
                        <div class="row">
                            <div class="col-sm-12 col-md-6 col-lg-6" v-if="observacion">
                                <b>Observación:</b>
                                {{ observacion }}
                            </div>
                        </div>
                        <br />
                        <br />
                        &nbsp;
                    </div>
                </div>
                </div>
            </b-modal>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
    name: "validarFraude",
    data(){
        return{
            dataObligaciones: [],
            form: {
                fecha_inicio : null,
                fecha_fin: null
            },
            perPage:10,
            item:[],
            observacion: ''
        }
    },
    computed:{
        // routeName() {
        //     return this.$router.currentRoute.name;
        // },
        ...mapGetters({
            loading: "loading",
        }),
        loading() {
            return this.$store.getters.loading;
        },
        data() {
            return this.$store.getters["pages/dataInformes"].datos;
        },
        dataLength() {
            if (this.$store.getters["pages/dataInformes"].paginacion.total === undefined) return 0;
            else return this.$store.getters["pages/dataInformes"].paginacion.total;
        },
    },
    components:{
        Titulo: () => import("@/containers/layout/Titulo.vue"),
        TableComponent: () => import("@/components/table/TableComponent"),
        TableColumn: () => import("@/components/table/TableColumn"),
    },
    methods: {
        async index(page = 1, paginar = false) {
            this.$store.dispatch("pages/fetch", {
                endpoint: "fraude",
                params: {
                    row: this.perPage,
                    page: page,
                    paginar: paginar,
                    ...this.form
                }
            });
        },
        checkbox(params){
            this.item = params;
        },
        async aplicarFraude(resuesta){
            if(confirm("vas a marcar esta operacón como " + resuesta + ". ¿Deseas continuar?")){
                this.$store.commit("SET_LOADING", true);
                try {
                    let response = await this.$store.state.api.post(
                        '/fraude/respuesta',
                        {
                            'ids': this.item,
                            'respuesta': resuesta
                        }
                    );

                    this.$toasted.success(response.data.mensaje, {
                        theme: "toasted-primary",
                        position: "top-right",
                        duration: 10000,
                    });
                    this.index();
                } catch (err) {
                    this.$toasted.error(
                        "Ocurrió un error al intentar procesar su solicitud.",
                        {
                        theme: "toasted-primary",
                        position: "top-right",
                        duration: 10000,
                        }
                    );
                }
                this.$store.commit("SET_LOADING", false);
            }
        },
        async clickEvent(data, slug){
            switch (slug) {
                case 'observacion':
                    this.observacion = data.observacion
                    this.$root.$emit("bv::show::modal", "modal-1", "#btnShow");

                    break;
                default:
                    break;
            }
        }
    },
    mounted() {
        this.index();
    },

}
</script>

<style>
.margin-informes .table-responsive {
    min-height: 15vh !important;
}
</style>